import { useEffect } from "react";
import client from "@/lib/api";
import { visibleInterval } from "@/lib/poll";

const last = {};

// Polls a tiny change-signal endpoint and fires window events only when something changed.
export function ChangeWatcher() {
  useEffect(() => {
    const check = () => client.get("/changes").then(({ data }) => {
      Object.entries(data).forEach(([k, v]) => {
        if (last[k] !== undefined && last[k] !== v) window.dispatchEvent(new Event(`changes:${k}`));
        last[k] = v;
      });
    }).catch(() => {});
    check();
    return visibleInterval(check, 3000);
  }, []);
  return null;
}

export function onChange(kind, fn) {
  const h = () => fn();
  window.addEventListener(`changes:${kind}`, h);
  return () => window.removeEventListener(`changes:${kind}`, h);
}
